<template>
  <div class="close-success">
    <CommonBanner :tagline="$t`Ваш Kaspi Red закрыт`" />
    <CommonBanner
      v-if="transferSrc"
      type="neutral"
      :additional="
        $gettext(`Мы перевели остаток Ваших денег <br /> на ${transferSrc}.`)
      "
    />
    <CommonButton spaced class="close-success__btn" @click="redirectToMain">
      {{ $t`Вернуться в Мой Банк` }}
    </CommonButton>
  </div>
</template>

<script>
import CommonBanner from "@/components/shared/banner/CommonBanner";
import CommonButton from "@/components/shared/button/CommonButton";

export default {
  components: {
    CommonBanner,
    CommonButton,
  },
  computed: {
    // Kaspi Gold || депозит
    transferSrc() {
      return this.$route.query.transfer;
    },
  },
  methods: {
    redirectToMain() {
      document.location.replace("/bank");
    },
  },
};
</script>

<style lang="scss" scoped>
.close-success {
  &__btn {
    &--bottom {
      position: fixed;
      width: 100vw;
      bottom: 0;
    }
  }
}
</style>
